import { showListing } from '../ListingPage/ListingPage.duck';
import { types as sdkTypes } from '../../util/sdkLoader';

const { UUID } = sdkTypes;

// loadData runs client-side only (route has noSSR: true in routeConfiguration).
// This avoids stale session cookie causing 401 → token refresh latency → mobile 502.
export const loadData = (params, search, config) => dispatch => {
  const listingId = new UUID(params.id);
  return dispatch(showListing(listingId, config));
};
